export enum ViewerIdPolicy {
	ALLOW = 'Allow',
	DISABLE = 'Disable',
	REQUIRE = 'Require'
}
